import styled from 'styled-components';

export const StyledNotFound = styled.div`
    height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    div[aria-label="animation"] {
        height: 350px !important;
        margin: 50px auto !important;
    }
`